// extracted by mini-css-extract-plugin
export default {"background":"_2FbNW","circle":"_2Jb3z","skeleton":"_2aZ0G","firstTitle":"_19BWJ","title":"_2wY7s","star":"_2KNPj","roundStar":"iPw4A","loupe":"_3vUiH"};